import React, {Component} from 'react';
import './notFound.scss'
export default class notFound extends Component {
  render() {    
    return (
      <div className="page-not-found">
        Hello notFound 
      </div>
    )
  }
}